import { LocationConfidenceScoresRecord } from "./models/locationConfidenceScoresRecord";
import LocationConfidenceScoresEntity from "./LocationConfidenceScoresEntity"
import { JSX } from "react";

interface LocationConfidenceScoresRecords {
  LocationConfidenceScoreRecords: LocationConfidenceScoresRecord[];
}

interface AccuracyEvidenceLocationConfidenceScoresTabProps {
  src: LocationConfidenceScoresRecord;
  srcList?: LocationConfidenceScoresRecords;
  expanding: boolean;
}

export default function AccuracyEvidenceLocationConfidenceScoresTab(evidence: AccuracyEvidenceLocationConfidenceScoresTabProps): JSX.Element {
  return (
    evidence.src ?
      <>
        <div className="card">
          <ul className="list-group list-group-flush">
            <li className="list-group-item bordered evidence-header">
              <div className="col-4">
                <b>Value</b>
              </div>
              <div className="col-4">
                <b>Value (Status)</b>
              </div>
              <div className="col-4">
                <b>Verification Reference</b>
              </div>
            </li>
            {evidence.srcList ?
              evidence.srcList.LocationConfidenceScoreRecords.map((lcs, i) => <div key={i}>
                  <LocationConfidenceScoresEntity locationConfidenceScore={lcs} />
                </div>)
                : <LocationConfidenceScoresEntity locationConfidenceScore={evidence.src} />}
          </ul>
        </div>
      </>
      : !evidence.expanding
        ? <p>No corroborating data found for this provider</p>
        : <p></p>
  );
}